<script>
  import { onMount } from "svelte";
  import { user } from "../../models/user.js";
  import { subscription } from "../../models/subscription.js";
  import { formatDate } from "../../services/utilities.js";
  $:loggedIn = ($user && $user.username);

  let justBought = false;

  onMount(() => {
    if ($subscription.hasSubscription){
      let startDate = formatDate($subscription.startDate, {showTime: false});
      let currentDate = formatDate(new Date(), {showTime: false});
      justBought = startDate === currentDate;
    }
  })
</script>

<section class="success">
  <h2>Thanks for Shopping With Us!</h2>
  {#if $subscription.hasSubscription && justBought}
    <p>If you purchased a subscription plan, please wait until your payment is authorized to checkout rentals for your subscription. You will receive an email with details about your plan.</p>
  {/if}
  {#if loggedIn}
    <a href="/account/orders">View your orders</a>
  {/if}
</section>

<style>
  .success {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
</style>
